import { TweenMax } from 'gsap';
import { SplitText } from '@/scripts/libs/SplitText';

const AwardsInitial = (element) => {
  const title = element.querySelector('.awards__title');
  const awards = [...element.querySelectorAll('.award')];
  const image = element.querySelector('.awards__image');

  const split = new SplitText(title, { charsClass: 'awards__title-char' });
  TweenMax.set(awards, { y: 100, autoAlpha: 0 });
  TweenMax.set(image, { autoAlpha: 0 });
  TweenMax.set(split.chars, { y: 80, autoAlpha: 0 });
};

export default AwardsInitial;
